import Caixa from './Caixa'
import HeaderVerde from './HeaderVerde'
import Input from './Input'
import React from 'react'

import { useSelector, useDispatch } from 'react-redux'
import { inputs } from '../../../state/slices/formSlice'

const DadosEstabelecimento = (props) => {
    const modulo = props.modulo
    const dispatch = useDispatch()
    const modo = useSelector((state) => state.addForm.modo)
    const ficha = useSelector((state) => state.addForm.modulos)

    function maskTelefone(value = '') {
        const digits = value.replace(/\D/g, '').slice(0, 11)

        if (digits.length <= 2) {
            return `(${digits}`
        }

        if (digits.length <= 7) {
            return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
        }

        return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
    }

    return (
        <Caixa>
            <HeaderVerde texto="DADOS DO ESTABELECIMENTO" />
            <div style={{ margin: "auto", width: "60vw" }}>
                <div style={{
                    display: "block", width: "60vw",
                    textAlign: "left", color: "#484848", marginTop: "2vh"
                }}>
                    <div>Estabelecimento</div>
                    <div style={{
                        width: "60vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                        borderRadius: "5px", minHeight: "5px"
                    }}>{ficha.dadosEstabelecimento[0].estabelecimento}</div>
                </div>
                <div style={{
                    display: "block", width: "60vw",
                    textAlign: "left", color: "#484848", marginTop: "2vh"
                }}>
                    <div>Nome Fantasia</div>
                    <div style={{
                        width: "60vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                        borderRadius: "5px", minHeight: "5px"
                    }}>{ficha.dadosEstabelecimento[0].fantasia}</div>
                </div>
                <div style={{ textAlign: "left" }}>
                    {/* <div style={{
                        display: "inline-grid", width: "28vw",
                        textAlign: "left", color: "#484848", marginTop: "2vh", marginRight: "4vw"
                    }}>
                        <div>Registro</div>
                        <div style={{
                            width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                            borderRadius: "5px", minHeight: "5px"
                        }}>{ficha.dadosEstabelecimento[0].registro}</div>
                    </div> */}
                    <div style={{
                        display: "inline-grid",
                        width: "28vw",
                        textAlign: "left",
                        color: "#484848",
                        marginTop: "2vh",
                        marginRight: "4vw"
                    }}>
                        <div>Registro</div>

                        {modo === "view" ? (
                            <div style={{
                                width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029", 
                                borderRadius: "5px", minHeight: "5px"
                            }}>
                                {ficha.dadosEstabelecimento?.[0]?.registro}
                            </div>
                        ) : (
                            <input
                                style={{
                                    width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029", 
                                    borderRadius: "5px", minHeight: "5px"
                                }}
                                name="registro"
                                defaultValue={ficha.dadosEstabelecimento?.[0]?.registro || ''}
                                onChange={e =>
                                    dispatch(inputs({
                                        e,
                                        modulo: 'dadosEstabelecimento',
                                        index: 0
                                    }))
                                }
                            />
                        )}
                    </div>
                    <Input label="Horário de Atendimento" nome="horarioAtendimento" modulo={modulo} index={0}
                        componentDisplay="inline-grid" widthWeb="28vw" widthMobile="80vw" />
                </div>
                <div style={{
                    display: "block", width: "60vw",
                    textAlign: "left", color: "#484848", marginTop: "2vh"
                }}>
                    <div>Endereço</div>
                    <div style={{
                        width: "60vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                        borderRadius: "5px", minHeight: "5px"
                    }}>{ficha.dadosEstabelecimento[0].endereco}</div>
                </div>
                <div style={{ textAlign: "left" }}>
                    <div style={{
                        display: "inline-grid", width: "28vw",
                        textAlign: "left", color: "#484848", marginTop: "2vh", marginRight: "4vw"
                    }}>
                        <div>Município</div>
                        <div style={{
                            width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                            borderRadius: "5px", minHeight: "5px"
                        }}>{ficha.dadosEstabelecimento[0].municipio}</div>
                    </div>
                    <div style={{
                        display: "inline-grid", width: "28vw",
                        textAlign: "left", color: "#484848", marginTop: "2vh"
                    }}>
                        <div>UF</div>
                        <div style={{
                            width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                            borderRadius: "5px", minHeight: "5px"
                        }}>{ficha.dadosEstabelecimento[0].uf}</div>
                    </div>
                </div>
                <div style={{ textAlign: "left" }}>
                    <div style={{
                        display: "inline-grid", width: "28vw",
                        textAlign: "left", color: "#484848", marginTop: "2vh", marginRight: "4vw"
                    }}>
                        <div>CEP</div>
                        <div style={{
                            width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                            borderRadius: "5px", minHeight: "5px"
                        }}>{ficha.dadosEstabelecimento[0].cep}</div>
                    </div>
                    <div style={{
                        display: "inline-grid", width: "28vw",
                        textAlign: "left", color: "#484848", marginTop: "2vh"
                    }}>
                        {/* <div>Telefone</div>
                        <div style={{
                            width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                            borderRadius: "5px", minHeight: "5px"
                        }}>{ficha.dadosEstabelecimento[0].telefone}</div> */}
                        <div style={{
                            display: "inline-grid", width: "28vw",
                            textAlign: "left", color: "#484848", marginTop: "2vh"
                        }}>
                            <div>Telefone</div>

                            {modo === "view" ? (
                                <div style={{
                                    width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                                    borderRadius: "5px", minHeight: "5px"
                                }}>
                                    {ficha.dadosEstabelecimento?.[0]?.telefone}
                                </div>
                            ) : (
                                <input
                                    style={{
                                        width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                                        borderRadius: "5px", minHeight: "5px"
                                    }}
                                    name="telefone"
                                    defaultValue={ficha.dadosEstabelecimento?.[0]?.telefone || ''}
                                    onChange={e => {
                                        const masked = maskTelefone(e.target.value)
                                        e.target.value = masked

                                        dispatch(inputs({
                                            e: { target: {
                                                    name: 'telefone',
                                                    value: masked
                                                }
                                            },
                                            modulo: 'dadosEstabelecimento',
                                            index: 0
                                        }))
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div style={{ textAlign: "left" }}>
                    <Input label="E-mail" nome="email" modulo={modulo} index={0}
                        componentDisplay="inline-grid" widthWeb="28vw" widthMobile="80vw" marginR="4vw" />
                    <Input label="Quantidade de Profissionais" nome="qtdProfissionais" tipo="number"
                        modulo={modulo} index={0}
                        componentDisplay="inline-grid" widthWeb="28vw" widthMobile="80vw" />
                </div>
            </div>
        </Caixa>
    )
}

export default DadosEstabelecimento